module.exports = __webpack_public_path__ + "img/strata-cinq-morceaux.d35ab51f.jpeg";